// @flow

import * as React from "react";

import styles from "./TooltipContent.scss";

export type TextType = {
  header: () => void,
  subheader: () => void
};

type TooltipContentProps = {
  texts: Array<TextType>
};

const TooltipContent = ({ texts }: TooltipContentProps) =>
  texts.map<React.Node>(({ header, subheader }, index) => (
    /* eslint-disable-next-line react/no-array-index-key */
    <React.Fragment key={`tooltip-${index}`}>
      <h2 className={styles.header}>{header()}</h2>
      <h3 className={styles.subheader}>{subheader()}</h3>
    </React.Fragment>
  ));

export default TooltipContent;
